import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';

const m = window.m;

/**
 * トップページかどうかを判定する
 * タグページ（/t/xxx）以外はすべてトップページとみなす
 */
function isHomePage() {
  return !m.route.param('tags');
}

app.initializers.add('butterflycode-homepage-config', () => {
  // トップページでは「スレッドを作成する」ボタンを非表示にする
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (isHomePage()) {
      items.remove('newDiscussion');
    }
  });
});
